import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginForm from './components/LoginForm';
import MainDashboard from './components/MainDashboard';
import AuthCallback from './components/AuthCallback';
import TestDashboard from './components/TestDashboard';
import { theme, gradients } from './theme';

const AppContent: React.FC = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{ background: gradients.primary }}
      >
        <div>Loading...</div>
      </Box>
    );
  }

  return (
    <Routes>
      {/* Auth callback route - always accessible */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Test Dashboard route */}
      <Route 
        path="/test-dashboard" 
        element={user ? <TestDashboard onLogout={logout} /> : <LoginForm />}
      />
      
      {/* Main routes */}
      <Route 
        path="/*" 
        element={user ? <MainDashboard onLogout={logout} /> : <LoginForm />}
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          background: gradients.dark,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 20%, rgba(124, 58, 237, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 50% 50%, rgba(139, 92, 246, 0.1) 0%, transparent 70%)
            `,
            pointerEvents: 'none',
            zIndex: 0,
          },
        }}
      >
        <Router>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </Router>
      </Box>
    </ThemeProvider>
  );
};

export default App;